import React, { useMemo } from "react";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import { useTranslate } from "ra-core";
import {
	Show,
	TabbedShowLayout,
	Tab,
	TextField,
	NumberField,
	DateField,
	BooleanField,
	FunctionField,
	Datagrid,
	useGetOne,
} from "react-admin";
import axios from "axios";
import { envSettings } from "../../settings/env";

export const PeerSupportGroupShow = (props) => {
	const translate = useTranslate();
	const { data: group, loading } = useGetOne("peer-support-groups", props.id);
	const [participants, setParticipants] = React.useState([]);

	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);

	React.useEffect(() => {
		if (props.id) {
			const baseUrl = envSettings.baseUrl;
			axios.get(`${baseUrl}/peer-support-groups/id/${props.id}/participants`, {
				withCredentials: true,
			})
				.then(({ data }) => {
					setParticipants(data.data || []);
				})
				.catch((error) => {
					console.error("Error fetching participants:", error);
					setParticipants([]);
				});
		}
	}, [props.id]);

	if (loading) return null;

	return (
		<Show {...props} title={translate("peerSupportGroups.show.title")}>
			<TabbedShowLayout>
				<Tab label={translate("peerSupportGroups.tabs.info")}>
					<TextField source={`title.${defaultLocale}`} />
					<TextField source={`description.${defaultLocale}`} />
					<TextField source={`topic.${defaultLocale}`} />
					<DateField source="sessionDatetime" showTime />
					<DateField source="feedbackSurveyTime" showTime />
					<NumberField source="minSpots" />
					<NumberField source="maxSpots" />
					<FunctionField
						label="Reminder"
						render={(record) =>
							record.reminderHoursBefore
								? `${record.reminderHoursBefore} hour${record.reminderHoursBefore > 1 ? "s" : ""}`
								: ""
						}
					/>
					<TextField
						source={`feedbackSurvey.name.${defaultLocale}`}
						label="Feedback Survey"
						emptyText="None"
					/>
					<BooleanField source="isActive" />
				</Tab>
				<Tab label={translate("peerSupportGroups.tabs.participants")} path="participants">
					{participants.length > 0 ? (
						<div style={{ padding: "16px" }}>
							<table style={{ width: "100%", borderCollapse: "collapse" }}>
								<thead>
									<tr style={{ borderBottom: "1px solid #e0e0e0" }}>
										<th style={{ padding: "12px", textAlign: "left" }}>First Name</th>
										<th style={{ padding: "12px", textAlign: "left" }}>Last Name</th>
										<th style={{ padding: "12px", textAlign: "left" }}>Email</th>
										<th style={{ padding: "12px", textAlign: "left" }}>Expressed Interest On</th>
									</tr>
								</thead>
								<tbody>
									{participants.map((participant) => (
										<tr key={participant.id} style={{ borderBottom: "1px solid #f0f0f0" }}>
											<td style={{ padding: "12px" }}>{participant.firstName}</td>
											<td style={{ padding: "12px" }}>{participant.lastName}</td>
											<td style={{ padding: "12px" }}>{participant.email}</td>
											<td style={{ padding: "12px" }}>
												{new Date(participant.expressedInterestOn).toLocaleString()}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					) : (
						<div style={{ padding: "16px" }}>No participants yet</div>
					)}
				</Tab>
			</TabbedShowLayout>
		</Show>
	);
};
